const surovyApiBase = process.env.REACT_APP_API_URL || '';

export const API_BASE = surovyApiBase.replace(/\/$/, '');

export function apiUrl(cesta) {
  const normalizovanaCesta = cesta.startsWith('/') ? cesta : `/${cesta}`;
  return API_BASE ? `${API_BASE}${normalizovanaCesta}` : normalizovanaCesta;
}